import { useTranslation } from 'react-i18next';
import React from 'react'
// ANTD
import { Col, Row } from 'antd'
// TYPEs
import { DataListType } from 'Types/common.types';
import { DetailsContainer } from 'Components/shared/details-container';

const VehicleInfo = ({
    driverDetails,
}) => {
    const { t } = useTranslation();
    const vehicleInfo:DataListType[] = [
        {
            label:t("label.driverOwnsVehicle"),
            value:driverDetails?.vehicleType == undefined ? 'no' : 'yes'
        },
        {
            label:t("label.vehicleType"),
            value:driverDetails?.vehicleType || '-'
        },
        {
            label:t("label.vehicleModel"),
            value:driverDetails?.vehicleModel || '-'
        },
        {
            label:t("label.plateNo"),
            value:driverDetails?.vehiclePlateNumber || '-'
        },
    ]

    return (
    <>
        <DetailsContainer
            listOfData={vehicleInfo}        
        />
    </>
  )
}

export default VehicleInfo